export default "__VITE_ASSET__OAOqqPTq__"